import React from 'react';
import { matchPath } from 'react-router';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '../../common/hooks/useQuery';
import { routeMappings } from '../../constants/routeMappings';
import { SessionStore } from '../../constants/sessionStore';
import { WorkflowItemCode } from '../../constants';
import { taskListDefaultConfiguration } from '../../taskList/constants';
import { useAppSelector } from '../../redux-store/hook';

interface LogoProps {
  src: string;
  alt: string;
  className?: string;
}

export const Logo = (props: LogoProps): JSX.Element => {
  const currentWorkflowItem = useAppSelector((state) => state.currentWorkflowItem);

  const { code, configuration } = currentWorkflowItem;

  const parsedConfig =
    configuration && code === WorkflowItemCode.TASKLIST
      ? JSON.parse(configuration).configWidgetJSON
      : taskListDefaultConfiguration;

  const linearflow = parsedConfig.linearflow === 'true';
  const showTaskList = parsedConfig.showTaskList === 'true';

  const history = useHistory();
  const location = useLocation();
  const query = useQuery();

  const userProfileUrl = matchPath(location.pathname, {
    path: routeMappings['USER_PROFILE'],
    exact: true,
  });

  const dpnUrl = matchPath(location.pathname, {
    path: routeMappings['DPN'],
    exact: true,
  });

  const taskUrl = matchPath(location.pathname, {
    path: `${routeMappings['TASK']}/:id`,
    exact: false,
  });

  const allowRedirect =
    (currentWorkflowItem.code === WorkflowItemCode.TASKLIST ||
      currentWorkflowItem.code === WorkflowItemCode.BASICTASKLIST) &&
    (!linearflow || (linearflow && showTaskList)) &&
    !sessionStorage.getItem(SessionStore.endPageConfig) &&
    (taskUrl || userProfileUrl || (dpnUrl && query.get('from')));

  const handleRedirect = (): void => {
    if (allowRedirect) {
      history.push(`${routeMappings[currentWorkflowItem.code]}/${currentWorkflowItem.id}`);
    }
  };

  return (
    <img
      src={props.src}
      alt={props.alt}
      className={props.className}
      onClick={handleRedirect}
      style={{ cursor: allowRedirect ? 'pointer' : '' }}
    />
  );
};
